import DepartureData from './DepartureData';
import { getValidationSchema } from './schema';

export { getValidationSchema };

export default DepartureData;
